import React from 'react';
import { List } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { formatDate } from '@/utils/dateHelper';
import { resolveRequestWorkflow } from '../state/state';

const RequestCreatedOnListItem = ({
  createdOn,
}) => (
  <List.Item className="aridhia-request-created-on-list-item">
    <List.Header>
      <FormattedMessage id="request.list.created.at.title" />
    </List.Header>
    <List.Description className="aridhia-form-item-description" content={createdOn} />
  </List.Item>
);

const mapStateToProps = ({
  requests: { requests },
  workflows: { workflows },
}, ownProps) => {
  const { request } = resolveRequestWorkflow(requests, workflows, ownProps);

  return (
    {
      createdOn: request && request.created_at ? formatDate(request.created_at) : '',
    }
  );
};

export default connect(mapStateToProps)(RequestCreatedOnListItem);
